<template>
  <div id="exchangeRefund">
    <el-page-header @back="goBack" content="退货退款"> </el-page-header>

    <el-row>
      <el-col :span="2">
        <div class="content-label">供应商名称</div>
        <div class="content-label">退货物流公司</div>
        <div class="content-label">退货物流单号</div>
        <div class="content-label">采购编号</div>
      </el-col>
      <el-col :span="22">
        <div class="content-span">{{ exchangeRefundInfo.supplierName }}</div>
        <div class="content-span">
          {{ exchangeRefundInfo.returnLogisticsOrgTypeLabel }}
        </div>
        <div class="content-span">
          {{ exchangeRefundInfo.returnLogisticsOrderNo }}
        </div>
        <div class="content-span">
          <el-button
            type="text"
            v-for="(item, index) in exchangeRefundInfo.returnInboundRecordIdSet"
            :key="item"
            @click="goStoreIn(item)"
          >
            {{
              item +
              (index == exchangeRefundInfo.returnInboundRecordIdSet.length - 1
                ? ""
                : ",")
            }}
          </el-button>
        </div>
      </el-col>
    </el-row>

    <refundSkuTable
      :tableData="refundSkuTableData"
      :refundTableData="refundTableData"
      ref="refundSkuTable"
    ></refundSkuTable>

    <exchangeStoreInTable
      :tableData="exchangeStoreInTableData"
      :exchangeRefundInfo="exchangeRefundInfo"
      ref="exchangeStoreInTable"
      @request-data="queryReturnDetail"
      @go-store-in="goStoreIn(id)"
    ></exchangeStoreInTable>

    <refundTable
      :tableData="refundTableData"
      :exchangeRefundInfo="exchangeRefundInfo"
      ref="refundTable"
      @add-fund="addFund"
      @operate-submit="operateSubmit"
    ></refundTable>

    <el-row class="padding-bottom-row">
      <el-col :span="2">
        <div class="content-label">备注</div>
      </el-col>
      <el-col :span="22">
        <el-row class="padding-bottom-row">
          <el-input
            v-model="remark"
            @change="remarkChange"
            placeholder="请输入备注"
            clearable
            v-if='exchangeRefundInfo.operateType == 1'
          ></el-input>
          <div class='content-span' v-else style="height: 20px;">
            {{exchangeRefundInfo.remark}}
          </div>
        </el-row>
        <el-row class="padding-bottom-row">
          <el-button type="primary" size="mini" @click="goBack">取消</el-button>
          <el-button type="primary" size="mini" @click="returnSuccess" v-if='exchangeRefundInfo.operateType == 1'
            >退回成功</el-button
          >
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { returnModules } from "@r";
import refundSkuTable from "./refundSkuTable";
import exchangeStoreInTable from "./exchangeStoreInTable";
import refundTable from "./refundTable";
import {createNamespacedHelpers} from 'vuex';
const { 
  mapGetters: returnMapGetters
} = createNamespacedHelpers('returnModel');
export default {
  components: {
    refundSkuTable,
    exchangeStoreInTable,
    refundTable,
  },
  data() {
    return {
      refundSkuTableData: [],
      exchangeStoreInTableData: [],
      refundTableData: [],
      remark: "",
    };
  },
  created() {
    this.exchangeRefundInfo = {};
  },
  activated() {
    const {id, operateType} = this.$route.query;
    this.exchangeRefundInfo = {...this.getReturnInfoById(id), operateType};
    this.queryReturnDetail();
    this.$nextTick(() => {
      this.$refs.refundSkuTable.$forceUpdate();
      this.$refs.exchangeStoreInTable.$forceUpdate();
      this.$refs.refundTable.$forceUpdate();
      this.$forceUpdate();
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goStoreIn(id) {
      location.href = "/client/storeIn?id=" + id;
    },
    addFund() {
      let addObject = {
        editAble: true,
        direction: 1,
        attachmentImageUrl: "",
        attachmentId: "",
        fromAccountName: "",
        toAccountName: "",
        amount: 0,
        fromAccountNo: "",
        toAccountNo: "",
        fromAccountOpenBank: "",
        toAccountOpenBank: ""
      };
      this.refundTableData.push(addObject);
    },
    operateSubmit(params) {
      returnModules.addOrUpdatePayRecord(params).then((res) => {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.queryReturnDetail();
      });
    },
    returnSuccess() {
      this.$confirm("是否确定提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          returnModules
            .editPurchaseReturnRecord({
              id: this.exchangeRefundInfo.id,
              returnAdjustStatus: 2,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "退回成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退回",
          });
        });
    },
    remarkChange() {
      returnModules
        .editPurchaseReturnRecord({
          remark: this.remark,
          id: this.exchangeRefundInfo.id,
        })
        .then((res) => {
              this.$message({
          type: 'success',
          message: '操作成功'
        });
        })
        .catch((err) => {
          this.remark = "";
        });
    },
    queryReturnDetail() {
      returnModules
        .detail({
          returnLogisticsOrgType: this.exchangeRefundInfo
            .returnLogisticsOrgType,
          returnLogisticsOrderNo: this.exchangeRefundInfo
            .returnLogisticsOrderNo,
        })
        .then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "详情获取失败",
            });
            return;
          }
          if (
            res.params.returnLogisticsOrderNo !=
            this.exchangeRefundInfo.returnLogisticsOrderNo
          ) {
            return;
          }
          this.refundTableData = res.mdata.payRecordDTOList;
          this.refundSkuTableData = res.mdata.inboundReturnDTOList;
          this.exchangeStoreInTableData = res.mdata.amazonInboundRecordDtoList;
          if (
            this.exchangeRefundInfo.operateType == 1 &&
            this.refundTableData.length == 0
          ) {
            this.addFund();
          }
        });
    },
  },
  computed: {
    ...returnMapGetters(['getReturnInfoById'])
  }
};
</script>
<style lang="scss">
.padding-bottom-row {
  padding-bottom: 10px;
}
.el-table td {
  padding: 0;
}
.content-label {
  padding: 5px 0;
  line-height: 20px;
  text-align: right;
}
.content-label::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}
.content-span {
  padding: 5px 0;
  line-height: 20px;
}
.el-button.el-button--text {
  padding: 0;
  margin: 0 10px 0 0;
}
.el-table__expanded-cell[class*="cell"] {
  padding: 0px 0px 0px 47px;
}
</style>